module.exports = __webpack_public_path__ + "static/toron-fd3fc03761342ac563a3f7f22d172b63.jpg";